import { render, staticRenderFns } from "./baggageType.vue?vue&type=template&id=8597225c&"
import script from "./baggageType.vue?vue&type=script&lang=js&"
export * from "./baggageType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports